import dayjs from 'dayjs'

// 日時の表示用フォーマット。view 層（components/view）から参照されるため common/util に置く。
// common/form/date.ts はここを再エクスポートしている。
export const dateStr = (date: Date | string): string => {
  return dayjs(date).format('YYYY/MM/DD')
}

export const dateTimeStr = (date: Date | string, options?: { omitSecond: boolean }): string => {
  return dayjs(date).format(options?.omitSecond ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD HH:mm:ss')
}

export const timeStr = (date: Date | string): string => {
  return dayjs(date).format('HH:mm:ss')
}

// 2つの日時の間の長さを「1時間2分」「3分4秒」「5秒」の形で返す。どちらかが無い・逆順のときは null。
export const durationStr = (
  from: Date | string | null | undefined,
  to: Date | string | null | undefined
): string | null => {
  if (!from || !to) return null
  const ms = dayjs(to).diff(dayjs(from))
  if (Number.isNaN(ms) || ms < 0) return null
  const totalSec = Math.floor(ms / 1000)
  const h = Math.floor(totalSec / 3600)
  const m = Math.floor((totalSec % 3600) / 60)
  const sec = totalSec % 60
  if (h > 0) return `${h}時間${m}分`
  if (m > 0) return `${m}分${sec}秒`
  return `${sec}秒`
}
